// Imports Angular
import { Component, OnInit, Input, NgZone, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { MatDialogRef, MatDialog } from '@angular/material';

// Imports Aplicacion
import { DRespuestaSimple, DError, DContextoMuisca, DServicio, DParametrosServicio, DTipoOperacionHttp } from '@dian/core';
import { DMensajeFirmado, DMensajeParaFirmar } from '@dian/api-firma';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DNotificacionServicio, DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DDocumento, DDocumentoAtributos, DFirmaElectronica, DFormularioServicio, DFirmantes, DFirmante } from '@dian/api-formulario';
import { DDatosCompartidosCabecera, DMensajes } from '@dian-cmp/formulario';
import { DDiligenciamientoServicios, DDocumentosPendientes, DFormatos, DFormato, DLink } from '@dian/api-diligenciamiento';

import { DDocumentoPendienteVista } from './../../to/ddocumento-pendiente-vista';
import { DDocumentosPendientesVista } from './../../to/ddocumentos-pendientes-vista';
import { DObjetoDocumentoFirmaVista } from './../../to/dobjeto-documento-firma-vista';
import { DFirmasConteoVista } from './../../to/dfirmas-conteo-vista';



@Component({
    moduleId: module.id,
    selector: 'gestor-firmas-component',
    templateUrl: 'gestor-firmas.component.html',
    styleUrls: ['gestor-firmas.component.css'],
    providers: [
        DNotificacionServicio,
        DDiligenciamientoServicios,
        DServicio
    ]
})
export class GestorFirmasComponent implements OnInit {
    
    
    private datosContexto:DContextoMuisca;  
    private documentoConsulta: string;
    private docs:DDocumentosPendientesVista;
    private xmlDocsSinFirmar: Array<DObjetoDocumentoFirmaVista>;
    private docsParaFirmar: number = 0;
    private docsParaFirmarPorcentaje: number = 0;    
    private docsParaPresentar: number = 0;
    private docsParaPresentarPorcentaje: number = 0;
    private esExtemporaneo: boolean = false;
    private habilitarOpciones: boolean = false;  
    private precargaProceso: MatDialogRef<DNotificacionesComponente>;
    private tipoDocumento: string;
    private progresoSpinnerMostrar: boolean = false;    
    private progresoSpinner: string = 'indeterminate';
    private progresoFirmas: number = 0;
    private progresoFirmasCantidadHechas: number = 0;
    private progresoFirmasCantidadError: number = 0;

    
    @ViewChild('firmarDocumentosModal') firmarDocumentosModal:ElementRef;
    

    constructor(
        private router: Router,
        private ngZone: NgZone,
        private activatedRoute: ActivatedRoute,
        private dNotificaciones: DNotificacionServicio,
        private dServicioREST: DDiligenciamientoServicios,
        private dServicioRESTApiFirma: DFormularioServicio,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private dServicioCore: DServicio
    ) {       
        this.docs = new DDocumentosPendientesVista(); 
        this.xmlDocsSinFirmar = new Array<DObjetoDocumentoFirmaVista>();
        // Referencia para ser encontrado por el script de AdmFirmaDigital.js
        window['angularComponentRef'] = {component: this, zone: ngZone};      
    }

    /**
    * @desc Función para llamar todos los metodos que carguen los elementos del formulario
    * como tambien los datos del formulario
    */
    ngOnInit() {
        setTimeout(() => {
            this.consultarFirmanteElectronico('desconocido');
        }, 50);        
    } 

    /**
    * @desc Función que se ejecuta cuando el componente se va a destruir
    */
    ngOnDestroy() {
        window['angularComponentRef'] = null;
    }


    // ====== Metodos propios del formulario ======

    /**
    * @desc Función para redirigir al dashboard
    * @function paginaDashboard
    * @ignore
    */
    private paginaDashboard() {
        window.location.href = location.origin + '/WebDashboard/DefDashboard.faces';
    } 

    /**
    * @desc Función para conocer si el contribuyente tiene firma electronica
    * @param {String} ideDocumento
    */
    private consultarFirmanteElectronico(ideDocumento:string) {
        let cargaFirmante = this.dNotificaciones.mostrarDialogoCarga();
        let observableServicio = this.dServicioREST.esFirmanteElectronico(ideDocumento);
        observableServicio.subscribe(
            res => {
                let firmaElectronica: DFirmaElectronica = <DFirmaElectronica>res;
                if (firmaElectronica.esFirmaElectronica) {
                    cargaFirmante.close();
                    this.consultarDatosContexto();
                } else {
                    cargaFirmante.close();
                    let dialogFirma = this.dNotificaciones.mostrarDialogoError(DMensajes.SIN_FIRMA_ELECTRONICA);
                    dialogFirma.afterClosed().subscribe(result => {
                        this.paginaDashboard(); 
                    }); 
                }
            },
            error => {
                cargaFirmante.close();
                this.dNotificaciones.mostrarDialogoError(DMensajes.ERROR_CONSULTANDO_SI_TIENE_FIRMA);
            }
        );        
    }

    /**
    * @desc Funcion que obtiene los datos del contexto para conocer el nit del contribuyente
    */
    private consultarDatosContexto() {
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();
        observableServicio.subscribe(
            res => {                
                this.datosContexto = <DContextoMuisca>res; 
                this.documentoConsulta = this.datosContexto.ANombrePropio ? this.datosContexto.NitUsuario : this.datosContexto.NitOrganizacion;
                this.tipoDocumento = this.datosContexto.ANombrePropio ? 'CC-' : 'NIT-';
                this.obtenerDocumentos(this.tipoDocumento + this.documentoConsulta);               
            }
        );    
    }

    /**
    * @desc Funcion para obtener los documentos listos para firmar
    * @param {String} documento
    */
    private obtenerDocumentos(documento: string) {
        this.progresoSpinner = 'indeterminate';  
        let cargaDocumentos = this.dNotificaciones.mostrarDialogoCarga();
        let observable = this.dServicioREST.consultarListaDocumentosPorFirmarPresentar(documento);    
        observable.subscribe(
            res => {
                let documentos: DDocumentosPendientes = <DDocumentosPendientes>res;                
                (<any>Object).assign(this.docs, documentos);
                cargaDocumentos.close();
                this.progresoSpinner = 'determinate';         
                this.obtenerDatosResumen();
                this.realizarConteoFirmas();

                if (documentos.dDocumentosPendientes && documentos.dDocumentosPendientes.length === 0) {
                    this.docsParaFirmarPorcentaje = 100;
                }
            },
            error => {
                cargaDocumentos.close();
                this.dNotificaciones.mostrarDialogoError("Error consultando documentos para firmar", error.mensaje);
            }
        );
    }
    
    /**
    * @desc Funcion para verificar si hay un documento seleccionado y habilitar el boton para firmar de lo contrario se deshabilita
    * @param {DDocumentoPendiente} doc
    */
    private verificarSeleccionDocs(doc:DDocumentoPendienteVista) { 
        doc.seleccionado = !doc.seleccionado;
        let bandera = false;
        let firmas = 0;
        for (let i in this.docs.dDocumentosPendientes) {
            if(this.docs.dDocumentosPendientes[i].seleccionado) {
                bandera = true;  
                firmas++;
            }
        }
        this.habilitarOpciones = bandera;        
        this.docsParaFirmar = firmas; 
        this.docsParaFirmarPorcentaje = this.determinarPorcentajes(firmas);    
    }

    /**
    * @desc Funcion para determinar la cantidad de documentos listos para firmar y para presentar
    */
    private obtenerDatosResumen() {
        this.docsParaPresentar = 0;
        for (let i in this.docs.dDocumentosPendientes) {
            if(this.docs.dDocumentosPendientes[i].paraPresentar) {
                this.docsParaPresentar++;
            }
        }
        this.docsParaPresentarPorcentaje = this.determinarPorcentajes(this.docsParaPresentar);
    }

    /**
    * @desc Funcion para determinar los porcentajes de firma y presentacion
    * @param {Number} valor
    * @return {Number}
    */
    private determinarPorcentajes(valor: number): number {
        //let max = this.docs.dDocumentosPendientes.length;
        let max = this.docs.dDocumentosPendientes ? this.docs.dDocumentosPendientes.length : 0;
        let porcentaje = valor / max;
        return porcentaje * 100;
    }    

    /**
    * @desc Función para presentar el formulario
    * @param {DDocumentoPendienteVista} doc
    */
    private presentarFormulario(doc: DDocumentoPendienteVista) {
        let precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
        
        let parametrosServicio = new DParametrosServicio();
        parametrosServicio.setOperacion(DTipoOperacionHttp.Actualizar);
        
        let href = doc.recurso.href;
        let documento = doc.recurso.rel;
        let observableServicio = this.dServicioCore.ejecutarServicioInternoURL(href + documento + '/presentar', parametrosServicio);  //=====corregir   
        observableServicio.subscribe(
            respuesta  => {           
                precargaProceso.close();
                this.dNotificaciones.mostrarDialogoInformacion('Documento presentado', DMensajes.PRESENTACION_EXITOSA);   
                this.obtenerDocumentos(this.tipoDocumento + this.documentoConsulta);                      
            },                 
            error =>{
                precargaProceso.close();
                this.dNotificaciones.mostrarDialogoError(DMensajes.PRESENTACION_NO_EXITOSA, error.mensaje);                  
            }
        );
    }  

    /**
    * @desc Función para imprimir el formulario
    * @param {DDocumentoPendienteVista} doc
    */
    private imprimirFormulario(doc: DDocumentoPendienteVista) {
        let precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
        let href = doc.recurso.href;
        let documento = doc.recurso.rel;       
        
        if (documento) {
            let observableServicio = this.dServicioCore.ejecutarServicioInternoURL(href + documento + '/descargar');  //=====corregir  
            let dinfodescarga:DRespuestaSimple = new DRespuestaSimple(); 
            observableServicio.subscribe(
                res  => {       
                    dinfodescarga = <DRespuestaSimple>res;              
                    let mediaType = 'application/pdf';
                    let blob = new Blob([dinfodescarga.blob], {type: mediaType});
                    let filename = documento + '.pdf';                            
                    window['saveAs'](blob, filename);   
                    precargaProceso.close();                 
                },                 
                error =>{
                    precargaProceso.close();
                    this.dNotificaciones.mostrarDialogoError(DMensajes.PROBLEMAS_CONSULTANDO_DOC + documento, error.mensaje);
                }
            );        
        } else {
            precargaProceso.close();
            this.dNotificaciones.mostrarDialogoError(DMensajes.IDENTIFICADOR_DOC_NO_DEFINIDO);                    
        }       
    }

    /**
    * @desc Function para obtener el conteo de las firmas hechas y pendientes por cada documento
    * @param {DFirmantes} firmantes
    */
    private realizarConteoFirmas() {
        let firmasHechas: number = 0;
        let firmasPendientes: number = 0;

        for (let i in this.docs.dDocumentosPendientes) {
            let firmantes = <DFirmantes>this.docs.dDocumentosPendientes[i].firmantes;
            for (var f in firmantes.firmantes) {
                let firmante = <DFirmante>firmantes.firmantes[f];
                if (firmante.autorizado) {
                    firmasPendientes++;
                }

                if (firmante.firmaExistente) {
                    firmasHechas++;
                }
            }

            let conteo = new DFirmasConteoVista(firmasHechas, firmasPendientes);
            this.docs.dDocumentosPendientes[i].firmasConteo = conteo;
        }
    }   

    /**
    * @desc Funcion para obtener todos los mensajes de cada documento para firmar
    */
    private obtenerMensajesParaFirma() {
        this.progresoSpinnerMostrar = true;
        let precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
        let observablesServicios = [];

        // Se agregan todos las peticiones de los servicios por cada documento a un array de observables
        for (let i in this.docs.dDocumentosPendientes) {
            if (this.docs.dDocumentosPendientes[i].seleccionado) {
                let href = this.docs.dDocumentosPendientes[i].recurso.href;
                let documento = this.docs.dDocumentosPendientes[i].recurso.rel;
                let observableServicioXML = this.dServicioCore.ejecutarServicioInternoURL(href + documento + '/mensajeparafirmar'); //=====corregir
                observableServicioXML.subscribe(
                    res => {
                        this.progresoFirmasCantidadHechas++;
                        this.progresoFirmas = this.determinarPorcentajes(this.progresoFirmasCantidadHechas);
                    }, 
                    error => {
                        this.progresoFirmasCantidadError++;
                    });
                observablesServicios.push(observableServicioXML); 
            }
        }                     
        
        // Espera la respuesta de todos los servicios llamados por documento
        Observable
            .forkJoin(observablesServicios)
            .map((result) => {          
                this.xmlDocsSinFirmar = new Array<DObjetoDocumentoFirmaVista>();

                for(let i in this.docs.dDocumentosPendientes) {
                    let mensajeParaFirmar: DMensajeParaFirmar = <DMensajeParaFirmar>result[i];  

                    //Extrae el mensaje del envoltorio del api de firma                    
                    let parser = new DOMParser();
                    let xmlDocParser = parser.parseFromString(mensajeParaFirmar.mensaje,"text/xml");
                    let msg = xmlDocParser.getElementsByTagName("Msg")[0];
                    let msgFirma = msg.getElementsByTagName("Msg")[0].textContent;                   
                    let objMensaje: DObjetoDocumentoFirmaVista = new DObjetoDocumentoFirmaVista(this.docs.dDocumentosPendientes[i].numeroDoc, msgFirma);                    
                    this.xmlDocsSinFirmar.push(objMensaje);                
                }

                precargaProceso.close();
                this.progresoSpinnerMostrar = false;
                this.firmarDocumentosModal.nativeElement.click();    
            })
            .subscribe();
    }

    /**
    * @desc Funcion que se ejecuta cuando le dan click al boton regresar del modal de firma roaming
    */
    public callbackFirmaCancelada() {
        console.log("CallbackFirmaCancelada");
        this.precargaProceso.close();
    }

    /**
    * @desc Funcion para obtener la respuesta de la firma de los documentos y ejecutar el servicio para guardar los documentos firmados
    * @param {String|Array<String>} xmlDocFirmados
    */
    public callbackFirmaDocumento(xmlDocsFirmados: any) {          

        xmlDocsFirmados = Array.isArray(xmlDocsFirmados) ? xmlDocsFirmados : [xmlDocsFirmados];   
        this.precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
        let observablesServicios = [];        

        for (let i in xmlDocsFirmados) {
            let objMensajeFirmado:DMensajeFirmado = new DMensajeFirmado();
            let parser = new DOMParser();
            let xmlDocParser = parser.parseFromString(xmlDocsFirmados[i],"text/xml");
            let idDocumento = xmlDocParser.documentElement.getAttribute('id');
            //let idDocumento = xmlDocParser.getElementsByTagName("Ref")[0].textContent;
            objMensajeFirmado.tipo = "XML";
            objMensajeFirmado.firmaMensaje = xmlDocsFirmados[i];
            objMensajeFirmado.mensajeOriginal.mensaje = xmlDocsFirmados[i];
            objMensajeFirmado.referencia = idDocumento;
            objMensajeFirmado.estado = 'firmado';
            objMensajeFirmado.error = null;
            
            // Obtengo el documento original y se inicializan los parametros del servicio
            let recurso: DLink = this.obtenerDocumentoDeLista(idDocumento);
            let parametrosServicio = new DParametrosServicio();        
            parametrosServicio.setOperacion(DTipoOperacionHttp.Crear);
            parametrosServicio.setJSONBody(objMensajeFirmado);               
            // Ejecuto los servicios por cada documento
            let observable = this.dServicioCore.ejecutarServicioInternoURL(recurso.href + recurso.rel + '/guardarfirma', parametrosServicio);
            observablesServicios.push(observable);
        }

        // Espera la respuesta de todos los servicios llamados por documento
        Observable
            .forkJoin(observablesServicios)
            .map((result) => {
                this.precargaProceso.close();
                let mensajeDetallado = "<h4>Firmas Realizadas</h4><br>Cantidad: " + this.progresoFirmasCantidadHechas + "<br><br><h4>Firmas con Errores</h4><br>Cantidad: " + this.progresoFirmasCantidadError; 
                this.dNotificaciones.mostrarDialogoInformacion("Firmas guardadas", mensajeDetallado);
                this.obtenerDocumentos(this.tipoDocumento + this.documentoConsulta);
            })
            //.do(console.log)
            .subscribe();            
    }

    /**
    * @desc Funcion para obtener los datos del documento y devolverlo para realizar operaciones
    * @param {String} idDocumento
    * @return {DLink}
    */
    private obtenerDocumentoDeLista(idDocumento: string): DLink {
        let recurso: DLink = new DLink();

        if(idDocumento && this.docs.dDocumentosPendientes.length) {
            for(let i in this.docs.dDocumentosPendientes) {
                if(this.docs.dDocumentosPendientes[i].numeroDoc === Number(idDocumento)) {
                    let documento = <DDocumentoPendienteVista>this.docs.dDocumentosPendientes[i];
                    recurso.rel = documento.recurso.rel;
                    recurso.href = documento.recurso.href;                                     
                    return recurso;
                }
            }
        } else {
            return recurso;
        }
    }

}



// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/components/gestor-firmas/gestor-firmas.component.ts